import { getGlobalConfigsValues } from "@infrastructure/Services/GlobalConfigsService";
import { GlobalConfigsType } from "@infrastructure/Persistence/GlobalConfigsStore";
import { isPlatformChecktok } from "@infrastructure/Services/EnvService";
import { isPlatformTrucktour } from "@infrastructure/Services/EnvService";

enum GlobalConfigsResponseNamesMap {
    "popular-posts-max" = "maxDashboardPostsCount",
    "suggested-groups-max" = "maxDashboardRecommendedGroupsCount",
    "group-chat-participants-max" = "groupChatMaxParticipants",
    "open-questions-max" = "openQuestionsMax",
    "tippspiel-create-comment-add-link-enabled" = "createCommentAddLinkEnabled",
    "create-message-add-link-enabled" = "createMessageAddLinkEnabled",
    "most-helpful-users-max" = "maxHelpfulUsersCount",
    "reisewelt-items-max" = "maxReisweltItemsCount",
    "suggested-posts-max" = "maxSuggestedPostsCount",
    "parent-group-posts-max" = "maxParentGroupPostsCount",
    "suggested-news-max" = "maxSuggestedNewsCount",
    "group-rating-page-enabled" = "groupRatingPageEnabled",
    "group-ratings-swiper-max" = "groupRatingsSwiperMax",
    "group-ratings-feed-max" = "groupRatingsFeedMax",
    "fallback-content-search-max" = "maxFallbackContentSearch",
    "content-search-on-input-version" = "contentSearchOnInputVersion",
    "tippspiel-feed-sorting-enabled" = "tippspielFeedSortingEnabled",
    "tippspiel-create-post-add-video-enabled" = "tippspielCreatePostAddVideoEnabled",
    "tippspiel-create-post-add-location-enabled" = "tippspielCreatePostAddLocationEnabled",
    "tippspiel-feed-enabled" = "tippspielFeedEnabled",
    "tippspiel-feed-create-post-placeholder" = "tippspielFeedCreatePostPlaceholder",
    "tippspiel-feed-create-post-enabled" = "tippspielFeedCreatePostEnabled",
    "tippspiel-feed-image-gallery-enabled" = "tippspielFeedImageGalleryEnabled",
    "tippspiel-feed-video-gallery-enabled" = "tippspielFeedVideoGalleryEnabled",
    "tippspiel-feed-groups" = "tippspielFeedGroups",
    "tippspiel-create-post-add-poll-enabled" = "tippspielCreatePostAddPollEnabled",
    "tippspiel-create-post-add-link-enabled" = "tippspielCreatePostAddLinkEnabled",
    "tippspiel-config-version" = "configVersion",
    "tippspiel-promotion-segment-headline" = "tippspielPromotionSegmentHeadline",
    "tippspiel-promotion-segment-posts" = "tippspielPromotionSegmentPosts",
    "tippspiel-comment-suggestions-enabled" = "tippspielCommentSuggestionsEnabled",
    "tippspiel-comment-suggestions-authorized-users" = "tippspielCommentSuggestionsAuthorizedUsers",
    "tippspiel-promotion-segment-position" = "tippspielPromotionSegmentPosition",
    "tippspiel-promotion-segment-slider-enabled" = "tippspielPromotionSegmentSliderEnabled",
}

enum ChecktokGlobalConfigsResponseNamesMap {
    "checktok-create-comment-add-link-enabled" = "createCommentAddLinkEnabled",
    "checktok-create-comment-add-location-enabled" = "createCommentAddLocationEnabled",
    "checktok-create-comment-add-video-enabled" = "createCommentAddVideoEnabled",
    "checktok-product-filter-enabled" = "checktokProductFilterEnabled",
    "checktok-product-group-filter-enabled" = "checktokProductGroupFilterEnabled",
    "checktok-avatar-generator-enabled" = "isAvatarGenerationEnabled",
    "checktok-config-version" = "configVersion",
}

enum TrucktourGlobalConfigsResponseNamesMap {
    "trucktour-create-comment-add-link-enabled" = "createCommentAddLinkEnabled",
    "trucktour-create-comment-add-location-enabled" = "createCommentAddLocationEnabled",
    "trucktour-create-comment-add-video-enabled" = "createCommentAddVideoEnabled",
    "trucktour-avatar-generator-enabled" = "isAvatarGenerationEnabled",
    "trucktour-config-version" = "configVersion",
    "trucktour-create-post-add-link-enabled" = "truckTourCreatePostAddLinkEnabled",
    "trucktour-create-post-add-location-enabled" = "truckTourCreatePostAddLocationEnabled",
    "trucktour-create-post-add-poll-enabled" = "truckTourCreatePostAddPollEnabled",
    "trucktour-create-post-add-video-enabled" = "truckTourCreatePostAddVideoEnabled",
    "trucktour-feed-create-post-placeholder" = "truckTourFeedCreatePostPlaceholder",
    "trucktour-create-post-enabled" = "truckTourCreatePostEnabled",
}

export function mappedGlobalConfigs() {
    const globalConfigs = {} as GlobalConfigsType;

    return getGlobalConfigsValues().then((globalDataConfigs) => {
        globalDataConfigs.map((globalDataConfig) => {
            switch (true) {
                case isPlatformChecktok:
                    globalConfigs[
                        ChecktokGlobalConfigsResponseNamesMap[
                            globalDataConfig.name
                        ]
                    ] = globalDataConfig.value;
                    break;
                case isPlatformTrucktour:
                    globalConfigs[
                        TrucktourGlobalConfigsResponseNamesMap[
                            globalDataConfig.name
                        ]
                    ] = globalDataConfig.value;
                    break;
                default:
                    globalConfigs[
                        GlobalConfigsResponseNamesMap[globalDataConfig.name]
                    ] = globalDataConfig.value;
                    break;
            }
        });
        return globalConfigs;
    });
}
